/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { JsonApiResource } from '@irian-ro/abstract-resource';
import { CommonModule } from '@angular/common';
import { ListboxModule } from 'primeng/listbox';
import { FormsModule } from '@angular/forms';
import { AddressDTO } from '@well/address-management-domain-model';
import { BsListboxComponent, BsListboxTemplateDirective } from 'iriro-frontend-libs/bs-component-store';
@Component({
  selector: 'well-local-address-list',
  templateUrl: './local-address-list.component.html',
  styleUrls: ['./local-address-list.component.scss'],
  standalone: true,
  imports: [CommonModule, ListboxModule, FormsModule, BsListboxComponent, BsListboxTemplateDirective],
})
export class LocalAddressListComponent {
  @Input() localAddresses: JsonApiResource<AddressDTO[], any> | undefined = undefined;

  selectedAddress: AddressDTO | undefined = undefined;

  @Output() addressSelect: EventEmitter<AddressDTO> = new EventEmitter<AddressDTO>();

  onSelect(event: AddressDTO) {
    this.addressSelect.next(event);
  }
}
